import axios from 'axios'
import { uuidv4 } from '@/helpers/uuid'

// Mutation types
const SET_CURRENT_SERVICE = 'SET_CURRENT_SERVICE'
const SET_FORM_COMPONENT = 'SET_FORM_COMPONENT'
const SET_CONFIGURATIONS = 'SET_CONFIGURATIONS'
const SET_CONFIGURATION = 'SET_CONFIGURATION'
const RESET = 'RESET'

// Urls
const BASE_URL = 'api/ServiceRegistry/Services'
const POST_CONFIGURATION_URL = (service) =>
  `${BASE_URL}/${service.Id}/Configurations`
const UPDATE_CONFIGURATION_URL = (service) =>
  `${BASE_URL}/${service.Id}/Configurations`
const GET_CONFIGURATION_URL = (service, configurationId) =>
  `${BASE_URL}/${service.Id}/Configurations/${configurationId}`
const GET_CONFIGURATIONS_URL = (service) =>
  `${BASE_URL}/${service.Id}/Configurations`
const GET_TENANT_CONFIGURATIONS_URL = (service) =>
  `${BASE_URL}/${service.Id}/Configurations/Tenant`
const DELETE_CONFIGURATION_URL = (service, configuration) =>
  `${BASE_URL}/${service.Id}/Configurations/${configuration.id}`
const VALIDATE_CONFIGURATION_URL = (service) =>
  `${BASE_URL}/${service.Id}/Configurations/Validate`
const EXECUTE_CONFIGURATION_URL = (isTestRun, processInstanceId) =>
  `${BASE_URL}/Execute` +
  `?isTestRun=${isTestRun}` +
  `&processInstanceId=${processInstanceId}`
const SET_SERVICE_CRON_URL = (service) =>
`${BASE_URL}/${service.Id}/Configurations/Cron`

let initialState = () => ({
  configurations: [],
  currentService: null,
  formComponent: null,
})

// Generate a guid
// function uuidv4() {
//   return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
//     var r = Math.random() * 16 | 0,
//       v = c == 'x' ? r : (r & 0x3 | 0x8)
//     return v.toString(16)
//   })
// }

export default {
  namespaced: true,
  state: initialState,
  actions: {
    addConfiguration(_, {
      service,
      configuration,
    }) {
      return axios.post(POST_CONFIGURATION_URL(service), configuration)
    },
    deleteConfiguration(_, {
      service,
      configuration,
    }) {
      if (!configuration || !configuration.id) {
        return Promise.reject(new Error('This configuration has no id, so it cannot be removed. Try reloading the page.'))
      }
      return axios.delete(DELETE_CONFIGURATION_URL(service, configuration))
    },
    updateConfiguration(_, {
      service,
      configuration,
    }) {
      return axios.put(UPDATE_CONFIGURATION_URL(service), configuration)
    },
    fetchConfiguration(_, {
      service,
      configurationId,
      params,
    }) {
      return axios.get(GET_CONFIGURATION_URL(service, configurationId), {
        params,
      })
    },

    // ONLY FOR the 'manageserviceconfigurations' page.
    // Make a new store page for anything else! 
    // Check out multistation.js, where 'queries' are used as configurations.
    setConfigurations({
      commit,
    }, configurations) {
      commit(SET_CONFIGURATIONS, configurations)
    },
    fetchConfigurations(_, service) {
      return axios.get(GET_CONFIGURATIONS_URL(service))
    },
    fetchTenantConfigurations(_, {
      service,
      tenantId = null,
      params = {},
    }) {
      return axios.get(GET_TENANT_CONFIGURATIONS_URL(service), {
        params: {
          tenantId,
          ...params,
        },
      })
    },
    validateConfiguration(_, {
      service,
      payload,
    }) {
      return axios.post(VALIDATE_CONFIGURATION_URL(service), payload)
    },
    setCurrentService({
      commit,
    }, service) {
      commit(SET_CURRENT_SERVICE, service)
    },
    setFormComponent({
      commit,
    }, formComponent) {
      commit(SET_FORM_COMPONENT, formComponent)
    },
    async executeImport(_, {
      processInstanceId = uuidv4(),
      service,
      serviceId,
      configuration,
      configurationId,
      payload = {}, // For services with payload
      isTestRun = false,
    }) {

      let executionModel = {
        tenantId: configuration.tenantId,
        serviceId: serviceId || service.Id,
        configurationId: configurationId || configuration.id,
        ...payload,
      }

      return axios.post(EXECUTE_CONFIGURATION_URL(isTestRun, processInstanceId), executionModel)
    },
    updateConfigurationCron({
      commit,
    }, {service, configuration}) {     
      return axios.post(SET_SERVICE_CRON_URL(service), configuration).then(() => {
        console.log('cron string saved, update value in browser')
        commit(SET_CONFIGURATION, configuration)
      }) 
      
    },
  },
  mutations: {
    [SET_CURRENT_SERVICE](state, service) {
      state.currentService = service
    },
    [SET_FORM_COMPONENT](state, formComponent) {
      state.formComponent = formComponent
    },
    [SET_CONFIGURATIONS](state, configurations) {
      state.configurations = configurations
    },
    [SET_CONFIGURATION](state, configuration) {
      var configurations = JSON.parse(JSON.stringify(state.configurations))
      let matchedIndex = configurations.findIndex(x => x.Id == configuration.id)      

      configurations.splice(matchedIndex, 1, configuration)
      state.configurations = configurations      
    },
    [RESET](state) {
      state.configurations = initialState.configurations
    },
  },
  getters: {
    configurations: (state) => state.configurations,
    currentService: (state) => state.currentService,
    formComponent: (state) => state.formComponent,
  },
}